import { Injectable, signal } from '@angular/core';

/**
 * Permite que cualquier componente sobreescriba el título que muestra el
 * brand-bar (la barra azul superior). Se limpia automáticamente en el
 * siguiente evento de navegación (ver app.ts).
 */
@Injectable({ providedIn: 'root' })
export class PageContextService {
  readonly titleOverride = signal<string | null>(null);

  set(title: string): void {
    this.titleOverride.set(title);
  }

  clear(): void {
    this.titleOverride.set(null);
  }
}
